var _                     = require('underscore');
var $                     = require('jquery');
var Core                  = require('../core/core.js');
var TrayTabTitle          = require('./tray__tab__title.js');
var TrayTabGridComponents = require('./tray__tab__gridcomponents.js');
var TrayTabListComponents = require('./tray__tab__listcomponents.js');
var TrayTabButton         = require('./tray__tab__button.js');
var TrayTabSearch         = require('./tray__tab__search.js');
var TrayTabSearchFilter   = require('./tray__tab__searchfilter.js');
var TrayTabSwitch         = require('./tray__tab__switch.js');

/**
 * Creates tray tabs
 *
 * @class
 */

class TrayTabs extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.filters = [];

        this.template = `
            <div class="editor__tray__tabs js-editor__tray__tabs">
                <div class="editor__tray__tabs__top js-editor__tray__tabs__top clearfix">
                    <div class="editor__tray__tabs__top__left js-editor__tray__tabs__top__left"></div>
                    
                    <div class="editor__tray__tabs__top__right js-editor__tray__tabs__top__right"></div>
                    <div class="editor__tray__tabs__top__searchcontainer">
                        <div class="js-editor__tray__tabs__top__search"></div>
                    </div>
                </div>
                <div class="editor__tray__tabs__sub js-editor__tray__tabs__sub hide"></div>
                <div class="editor__tray__tabs__content js-editor__tray__tabs__content"></div>
            </div>
        `;

        super.render();

        /**
         * Scroll event
         *
         * @fires TrayTabs#_scrolled
         */

        var self = this;
        $(".js-editor__tray__tabs__content", this.$el).on('scroll', function(e){
            self._scrolled(e, self.$el);
        });


    }

    /**
     * @event TrayTabs#Cioui:TrayTabs:Scrolled
     * @property {String}Cioui:TrayTabs:Scrolled
     * @returns {Object} event - native Event
     */

    _scrolled(e, ref){
        $(ref).trigger('Cioui:TrayTabs:Scrolled', {"distanceToBottom": this.distanceToBottom()});
    }

    distanceToBottom(){
        var contentHeight = $(".js-editor__tray__tabs__content", this.$el).children().filter(":visible").outerHeight(true);
        var scrollPos = $(".js-editor__tray__tabs__content", this.$el).scrollTop();
        var parentHeight = $(".js-editor__tray__tabs__content", this.$el).outerHeight(true);
        var distanceToBottom = contentHeight - parentHeight - scrollPos;
        return distanceToBottom;
    }

    /**
     * Adds a title to the tabs top navigation
     */
    addTitle(title){
        return new TrayTabTitle({
            target: $('.js-editor__tray__tabs__top__left', this.$el),
            fields: {
                'title': title
            }
        });
    }

    /**
     * Adds a search box to the tab
     * @param {String} placeholder - placeholder
     */
    addSearchbox(placeholder,enableFiltering){
        return new TrayTabSearch({
            target: $('.js-editor__tray__tabs__top__search', this.$el),
            fields: {
                'placeholder': placeholder,
                'enableFiltering': enableFiltering
            },
        });
    }

    hideSearchbox(){
        $('.js-editor__tray__tabs__top__search', this.$el).hide();
    }

    showSearchbox(){
        $('.js-editor__tray__tabs__top__search', this.$el).show();
    }

    /**
     * Adds a search box to the tab
     * @param {String} placeholder - placeholder
     */
    addSearchFilter(index, filterData, onblur){
         // this is a bit hacky but apparently the best solution to 
        // fix the issue with CC and template strings
        var htmlFilterList = {};
        var props = filterData.properties;
        // this is a list of all properties, each containing their display fields as 
        // string literals
        for(var key in props){
            if(props.hasOwnProperty(key)){
                htmlFilterList[key] = {};
                htmlFilterList[key]["serverName"] = props[key].serverName;
                htmlFilterList[key]["displayTitle"] = props[key].displayTitle;
            }
        }

        // now options are ready for templates to access data

        var filter = new TrayTabSearchFilter({
            target: $('.js-editor__tray__tabs__sub', this.$el),
            fields: {
                'startingIndex': index,
                'filters': props,
                'filterData': filterData,
                'htmlFilterList': htmlFilterList
            }
        });
        this.updateContentTop();
        this.filters.push(filter);
        filter.setOnBlur(onblur);
        return filter;
    }

    removeSearchFilter(index){
        this.filters[index].remove();
        this.filters.splice(index, 1);
        this.updateContentTop();
    }

    // when this is getting called, the index in the list and the 
    // index of the object have already decreased.  just need to decrease
    // the index according to the 
    decreaseIndex(filterIM){
        this.filters[filterIM.index()].decreaseIndex();
    }

    setFilterValues(filterIM){
        this.filters[filterIM.index()].setValues(filterIM);
    }

    hideSearchFilters(){
        $('.js-editor__tray__tabs__sub', this.$el).hide();
        this.updateContentTop();
    }

    showSearchFilters(){
        $('.js-editor__tray__tabs__sub', this.$el).show();
        this.updateContentTop();
    }

    /**
     * Add a button to the right side of the tabs top menu
     * @param {String} name - name for the tool
     * @param {String} description
     * @param {String} icon - icon string
     */
    addButton(title, description, icon){
        return new TrayTabButton({
            target: $('.js-editor__tray__tabs__top__right', this.$el),
            fields: {
                'title': title,
                'description': description,
                'icon': icon
            }
        });
    }
 
    updateContentTop(){
        var top = 0;
        top += $('.js-editor__tray__tabs__top', this.$el).height();
        if ($('.js-editor__tray__tabs__sub', this.$el).is(":visible"))
            top += $('.js-editor__tray__tabs__sub', this.$el).height();
        $('.js-editor__tray__tabs__content', this.$el).css('top', top);
    }

    /**
     * Adds a tray content with large component thumbs
     */
    addGridComponentsInnerTray(viewConfig){
        var config = {
            target: $('.js-editor__tray__tabs__content', this.$el)
        };

        //store column names as array in options if provided
        if(viewConfig) {
            config.viewConfig = viewConfig;
        }

        return new TrayTabGridComponents(config);

    }

    /**
     * Adds a tray content with large component thumbs
     */
    addListComponentsInnerTray(viewConfig){
        var config = {
            target: $('.js-editor__tray__tabs__content', this.$el)
        };

        //store column names as array in options if provided
        if(viewConfig) {
            config.viewConfig = viewConfig;
        }

        return new TrayTabListComponents(config);
    }

    /**
     * Adds a tray switch icon to switch between list and component view
     */
    addSwitch(){
        return new TrayTabSwitch({
            target: $('.js-editor__tray__tabs__top__right', this.$el)
        });
    }

}
module.exports = TrayTabs;
